import type { GoogleGeocoderAddressComponent, ParsedAddress } from "../types";

export const parseAddressComponents = (addressComponents: GoogleGeocoderAddressComponent[]) => {
    const builtAddress: Partial<ParsedAddress> = {};

    for (const addressComponent of addressComponents) {
        switch (addressComponent.types[0]) {
            case "street_number":
                builtAddress.streetNumber = addressComponent.long_name;
                break;
            case "route":
                builtAddress.route = addressComponent.long_name;
                break;
            case "floor":
                builtAddress.floor = addressComponent.long_name;
                break;
            case "sublocality_level_2":
                builtAddress.subLocalityLevel2 = addressComponent.long_name;
                break;
            case "postal_code":
                builtAddress.postalCode = addressComponent.short_name;
                break;
            case "point_of_interest":
            case "establishment":
                builtAddress.name = addressComponent.long_name;
                break;
            default:
                break;
        }
    }

    return builtAddress;
};
